<template>
  <Modal :show="true" centered size="xxl" title="Endose Liquidar" @hide="$emit('hide', containers.recargarPagina)" bodyClass="p-0">
    <Spinner v-if="loading.view" class="py-5"></Spinner>
    <template v-else>
      <div class="card-body">
        <div class="row align-items-center">
          <div class="col-lg">
            <ul class="list-inline mb-0">
              <li class="list-inline-item"><strong>Agencia:</strong> {{ modalItem.agencia }}</li>
              <li class="list-inline-item"><strong>Pasajero:</strong> {{ modalItem.pasajero }}</li>
              <template v-if="estaLiquidado && !masDeUnaMoneda">
                <li class="list-inline-item"><strong>Código Liquidación:</strong> {{ containers.liquidado.codigoLiquidacion }}</li>
                <li class="list-inline-item"><strong>Fecha Liquidación:</strong> {{ containers.liquidado.fechaLiquidacion | date }}</li>
              </template>
            </ul>
          </div>
          <div v-if="containers.steps.similares" class="col-lg-5 text-md-right">
            <Button v-if="!estaLiquidado" @click="onLiquidar" :disabled="loading.save" class="btn-sm mr-2">Liquidar</Button>
            <template v-else>
              <router-link v-if="!masDeUnaMoneda" :to="{ name: 'liquidaciones', query: { codLiquidacion: containers.liquidado.codigoLiquidacion } }" class="btn btn-sm btn-outline-success mr-2" target="_blank">
                Ver Liquidación
              </router-link>
              <template v-else>
                <router-link v-for="item in liquidaciones" :key="item.codigo" :to="{ name: 'liquidaciones', query: { codLiquidacion: item.codigo } }" class="btn btn-sm btn-outline-success mr-2" target="_blank"> Ver Liquidación {{ item.moneda }} </router-link>
              </template>
            </template>
            <Button @click="onPrint" :variant="'outline-secondary'" class="btn-sm">Imprimir</Button>
          </div>
        </div>
      </div>
      <template v-if="!containers.steps.similares">
        <div class="card-body">
          <p class="text-muted"><i class="fa fa-fw fa-info-circle"></i> Seleccione para agregar registros a la liquidación</p>
          <Table :rows="containers.similares" :columns="columnsSimilares" :columnID="'idEndose'">
            <template #rowactions="{ row }">
              <input type="checkbox" v-model="row.checked" />
            </template>
            <template #rowfecha="{ val}">{{ val | date }}</template>
          </Table>
          <div class="text-right">
            <Button @click="onSiguiente" :disabled="loading.siguiente">Siguiente <i class="fa fa-fw fa-arrow-right"></i></Button>
          </div>
        </div>
      </template>
      <template v-else>
        <ValidationObserver ref="formLiquidacion">
          <div class="card-body">
            <p v-if="masDeUnaMoneda" class="text-right text-primary mb-0"><i class="fa fa-fw fa-info-circle"></i> Se crearán diferentes liquidaciones por cada moneda</p>
          </div>
          <Table :rows="containers.endosados" :columns="columnsLiquidacion" :columnID="'id'" containerClass="m-0">
            <template #rows="{ rows }">
              <EndosadoLiquidarRow v-for="row in rows" :key="row.id" :item="row" :liquidado="estaLiquidado" :monedas="containers.monedas"></EndosadoLiquidarRow>
              <tr class="table-secondary" v-for="(val, moneda) in total" :key="moneda">
                <td :colspan="9" class="text-right">
                  <strong>TOTAL {{ moneda }}</strong>
                </td>
                <td class="text-center">{{ val | number(2) }}</td>
                <td></td>
              </tr>
            </template>
          </Table>
        </ValidationObserver>
      </template>
    </template>
  </Modal>
</template>

<script>
import EndosadoLiquidarRow from "./EndosadoLiquidarRow.vue";
import Button from "../../shared/components/Button.vue";
import Table from "../../shared/components/Table.vue";
// import OrdenDeServicioLiquidarTable from "./OrdenDeServicioLiquidarTable.vue";
import Spinner from "../../shared/components/Spinner.vue";
import Modal from "../../shared/components/Modal.vue";
import pdfEndoseLiquidacion from "../../../pdfs/pdfEndoseLiquidacion";

export default {
  components: { Modal, Spinner, Table, Button, EndosadoLiquidarRow },
  props: {
    show: {
      type: Boolean,
      default: true,
    },
    modalItem: {
      type: null,
      default: null,
    },
  },
  data() {
    return {
      loading: {
        view: true,
        siguiente: false,
        save: false,
      },
      containers: {
        similares: [],
        endosados: [],
        liquidado: null,
        monedas: [],
        steps: {
          similares: false,
        },
        recargarPagina: false,
      },
    };
  },
  async created() {
    let vm = this;
    let response;

    try {
      response = await vm.axios.get(`/endosados/${vm.modalItem.idEndose}/liquidar/similares`);
    } catch (error) {
      return;
    }

    vm.containers.similares = response.data.content.similares.map((item) => ({
      ...item,
      checked: true,
    }));

    if (response.data.content.liquidado) {
      vm.containers.steps.similares = true;

      vm.containers.endosados = response.data.content.registros.map((item, index) => {
        return {
          ...item,
          observaciones: item.observaciones,
          id: index + 1,
          codigo: item.codigoEndose,
          tempMoneda: item.moneda,
        };
      });

      vm.containers.liquidado = response.data.content.liquidado;
    } else {
      if (!vm.containers.similares.length) {
        vm.containers.steps.similares = true;
        vm.onSiguiente();
      }
    }

    vm.loading.view = false;
  },
  computed: {
    total() {
      const tienen_moneda = this.containers.endosados.filter((item) => item.tempMoneda);

      const monedas = {};

      tienen_moneda.forEach((item) => {
        if (monedas[item.tempMoneda]) {
          monedas[item.tempMoneda] = monedas[item.tempMoneda] + Number(item.tarifa);
        } else {
          monedas[item.tempMoneda] = Number(item.tarifa);
        }
      });

      return monedas;
    },
    masDeUnaMoneda() {
      const monedas = Object.keys(this.total);
      return monedas.length > 1 ? true : false;
    },
    monedaPorId() {
      return this.containers.monedas.reduce((obj, item) => {
        obj[item.idMoneda] = item.sigla;
        return obj;
      }, {});
    },
    liquidaciones() {
      const vm = this;
      const liquidaciones = [];

      Object.keys(vm.containers.liquidado.codigo).forEach((idMoneda) => {
        liquidaciones.push({
          codigo: vm.containers.liquidado.codigo[idMoneda],
          moneda: vm.monedaPorId[idMoneda],
          fecha: vm.containers.liquidado.fecha[idMoneda],
        });
      });

      return liquidaciones;
    },
    estaLiquidado() {
      return !!this.containers.liquidado;
    },
    columnsSimilares() {
      return [
        {
          key: "actions",
          label: "",
          width: 25,
          row_class: "text-center",
        },
        {
          key: "codigo",
          width: 60,
          head_class: "text-center",
          row_class: "text-center",
        },
        {
          key: "fecha",
          width: 70,
          head_class: "text-center",
          row_class: "text-center",
        },
        {
          key: "pasajero",
        },
        {
          key: "file",
          width: 70,
          head_class: "text-center",
          row_class: "text-center",
        },
        {
          key: "nroAdultos",
          label: "PAX",
          width: 40,
          head_class: "text-center",
          row_class: "text-center",
        },
        {
          key: "nroNinos",
          label: "CHD",
          width: 40,
          head_class: "text-center",
          row_class: "text-center",
        },
        {
          key: "agencia",
        },
        {
          key: "servicio",
        },
      ];
    },
    columnsLiquidacion() {
      return [
        {
          key: "fecha",
          width: 70,
          head_class: "text-center",
        },
        {
          key: "codigo",
          width: 70,
          head_class: "text-center",
        },
        {
          key: "file",
          width: 90,
        },
        {
          key: "servicio",
        },
        {
          key: "hotel",
        },
        {
          key: "servicioTipo",
          label: "Tipo",
          width: 90,
          head_class: "text-center",
        },
        {
          key: "nroAdultos",
          label: "PAX",
          width: 40,
          head_class: "text-center",
        },
        {
          key: "nroNinos",
          label: "CHD",
          width: 40,
          head_class: "text-center",
        },
        {
          key: "moneda",
          width: 60,
          head_class: "text-center",
        },
        {
          key: "tarifa",
          label: "Monto",
          width: 60,
          head_class: "text-center",
        },
        {
          key: "observaciones",
        },
      ];
    },
  },
  methods: {
    async onSiguiente() {
      const vm = this;
      let registros = [];
      registros.push(vm.modalItem);
      const similaresSeleccionados = vm.containers.similares.filter((item) => item.checked);
      registros.push(...similaresSeleccionados);

      const fd = registros.map((item) => ({
        idEndose: item.idEndose,
        idAgencia: item.idAgencia,
        idServicio: item.idServicio,
        idServicioTipo: item.idServicioTipo,
        nroAdultos: item.nroAdultos,
        nroNinos: item.nroNinos ?? null,
      }));

      vm.loading.siguiente = true;

      try {
        const response = await vm.axios.post(`/endosados/${vm.modalItem.idEndose}/liquidar/tarifas`, { registros: fd });

        if (response.data.content.liquidado) {
          registros = response.data.content.registros.map((item, index) => {
            return {
              ...item,
              id: index + 1,
              tempMoneda: item.moneda || "USD",
            };
          });
        } else {
          registros = registros.map((item, index) => {
            let tarifa = response.data.content.registros.find((itemTarifa) => itemTarifa.idAgencia == item.idAgencia && itemTarifa.idServicio == item.idServicio && itemTarifa.idServicioTipo == item.idServicioTipo);

            console.log({ item, tarifa });

            return {
              ...item,
              tarifa: Number(tarifa?.tarifa || 0).toFixed(2),
              observaciones: tarifa?.liquidado || tarifa.observaciones || "",
              id: index + 1,
              tempMoneda: tarifa?.moneda || "USD",
            };
          });
        }

        vm.containers.monedas = response.data.content.monedas;
        vm.containers.endosados = registros;
        vm.containers.liquidado = response.data.content.liquidado;
        vm.containers.steps.similares = true;
      } catch (error) {
        console.error({ error });
      } finally {
        vm.loading.siguiente = false;
      }
    },
    async onLiquidar() {
      const vm = this;

      const validated = await vm.$refs.formLiquidacion.validate();
      if (!validated) {
        vm.$toast.fire({ title: "Completa los campos requeridos", icon: "warning" });
        return;
      }

      const id_por_moneda = vm.containers.monedas.reduce((obj, item) => {
        obj[item.sigla] = item.idMoneda;
        return obj;
      }, {});

      const list = [...vm.containers.endosados].map((item) => {
        return {
          ...item,
          idMoneda: id_por_moneda[item.tempMoneda],
          moneda: item.tempMoneda,
        };
      });

      vm.loading.save = true;

      vm.axios
        .post(`/endosados/${vm.modalItem.idEndose}/liquidar`, {
          items: list,
          total: this.total,
        })
        .then((response) => {
          const liquidacion = response.data.content.liquidacion;
          const liquidacionKeys = Object.keys(liquidacion.codigo);

          if (liquidacionKeys.length > 1) {
            vm.containers.liquidado = response.data.content.liquidacion;
          } else {
            vm.containers.liquidado = {
              codigoLiquidacion: liquidacion.codigo[liquidacionKeys[0]],
              fechaLiquidacion: liquidacion.fecha[liquidacionKeys[0]],
            };
          }
          vm.containers.recargarPagina = true;
          vm.$toast.fire({ title: response.data.message, icon: "success" });

          vm.containers.endosados = list;
        })
        .finally(() => {
          vm.loading.save = false;
        });
    },
    onPrint() {
      const vm = this;

      const items = vm.containers.endosados.map((item) => ({
        fecha: vm.$options.filters.date(item.fecha),
        codigo: item.codigo,
        file: item?.file || "",
        servicio: item.servicio || item.otroServicio || "",
        hotel: item.hotel || item.otroHotel || "",
        servicioTipo: item.servicioTipo || item.otroServicioTipo || item.serviciotipo || "",
        nroAdultos: item.nroAdultos,
        nroNinos: item?.nroNinos || "",
        moneda: vm.estaLiquidado ? item.moneda : item.tempMoneda,
        tarifa: {
          alignment: "center",
          text: vm.$options.filters.number(item.tarifa, 2),
        },
        observaciones: item.observaciones || "",
      }));

      Object.keys(vm.total).forEach((moneda) => {
        items.push({
          fecha: {
            colSpan: 9,
            alignment: "right",
            text: `TOTAL ${moneda}`,
          },
          tarifa: {
            alignment: "center",
            text: vm.$options.filters.number(vm.total[moneda], 2),
          },
          observaciones: "",
        });
      });

      pdfEndoseLiquidacion({
        items,
        header: {
          agencia: vm.modalItem.agencia,
          pasajero: vm.modalItem.pasajero,
          codigoLiquidacion: vm.estaLiquidado ? vm.containers.liquidado.codigoLiquidacion : "",
          fechaLiquidacion: vm.estaLiquidado ? vm.$options.filters.date(vm.containers.liquidado?.fechaLiquidacion || vm.liquidaciones[0]?.fecha) : "",
          liquidaciones: vm.estaLiquidado && vm.masDeUnaMoneda ? vm.liquidaciones : [],
          masDeUnaMoneda: vm.masDeUnaMoneda,
        },
        preview: !vm.estaLiquidado,
        userMark: vm.$store.state.user,
        dateMark: vm.$dayjs().format("DD-MM-YY HH:mm"),
      });
    },
  },
};
</script>
